import Vue from 'vue'
import Vuex from 'vuex'
import Store from './store/index'
Vue.use(Vuex)

export default Store;
